module.exports = __webpack_public_path__ + "img/simular.6775c6b0.png";